var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.routeChildren.code},on:{"click":function($event){return _vm.handleLink(_vm.routeChildren.path)}}},[_c('span',[_vm._v(_vm._s(_vm.routeChildren.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }